// TODO: Chanage the caps letters, bundle related constants into one object
const OVERLAY_MESSAGE =
	'Some features may not display correctly because of your screen size.'
const TABLEAU_DASH_CATEGORIES = {
	FREQUENTLY_USED: 'Frequently Used',
	FOLDER: 'Folder'
}

const NO_PUC = 'No PUC'
const DEFAULT_PUC = 'default'
const PASSWORD_REGEX = /(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z!@#$%^&*]{8,32}/g
const PASSWORD_VALIDATION_MESSAGE =
	'Password should be at least 8 characters with at least one number, one lower case letter, one uppercase letter and one special character.'
const CONFIRM_PASSWORD_VALIDATION_MESSAGE = 'Password does not match'
const UserGroups = {
	Admin: 'Admin'
}
const FIELDLENGTH_ERROR = 'Must be at most 50 characters.'
const REQUIRED = 'Required'
const MIN_LATITUDE = 'Must be greater that -90'
const MAX_LATITUDE = 'Must be less than 90'
const MIN_LONGITUDE = 'Must be greater that -180'
const MAX_LONGITUDE = 'Must be less than 180'
const NUMBER = 'Must be a number'
const MAX_PHB_NUMBER = 'Must be at most 10 characters.'

const MODULES = {
	DueDiligence: 'DueDiligence',
	Demand: 'Demand',
	MRL: 'MRL',
	Supply: 'Supply',
	MasterData: 'MasterData',
	Security: 'Security',
	CropCensus: 'CropCensus',
	AgronomyEstimates: 'Agronomy',
	GrowerEstimates: 'Estimates',
	Tableau: 'Tableau'
}

const PERMISSIONS = {
	Read: 'Read',
	Update: 'Update',
	Delete: 'Delete',
	Create: 'Create'
}

const HECTARES_VAL_ERR = {
	MAX: 'Must be less than or equal to 1000',
	MIN: 'Must be greater than or equal to 0'
}

const METRICS = {
	KG: 'KG',
	PERCENT: '%'
}

const Disposal_Val_Err = (value) => {
	return {
		maxDate: 'Disposal date cannot be in the future.',
		maxDisposalAmount: `You can not dispose more than ${value} (the number of plants on the block)`
	}
}

const Block_Source = 'Another Block'

const Date_Val_Err = (name) => {
	return {
		future: `${name} cannot be in the future`,
		past: `${name} cannot be in the past`
	}
}

const Number_Val_Err = (value) => {
	return {
		max: `Cannot be greater than ${value}`,
		equal: `Must be equal to ${value}`,
		min: `Cannot be less than ${value}`
	}
}
const Crop_Census_Tranfers_Val_Err = (max) => {
	return {
		numberOfPlants_max: `Can not transfer more than ${max}`
	}
}

const Sentry_Custom_Err = {
	Crop_Census_Dropdown:
		'An error has occurred on one of the crop census dropdowns'
}

const Dirty_Form_Message = {
	default:
		'It looks like you have been editing something. If you continue before saving, your changes will be lost.',
	gridEdits:
		'It looks like you have been editing something on the grid. If you continue before saving, your changes will be lost.',
	yieldDistribution:
		'Please note that you will lose all unsaved changes if you choose to apply new filters.'
}

const AgGrid_Header_Template = `<div class="ag-cell-label-container" role="presentation">
    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
      <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>
      <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>
      <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>
      <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>
      <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: pre-wrap !important;"></span>
      <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
    </div>
  </div>`

const StartEndDates_Val_Err = (name) => {
	return {
		start: `${name} Start Date can not be after ${name} End Date.`,
		end: `${name} End Date can not be before ${name} Start Date.`
	}
}
const Agronomy_AdjustmentEvent_Save_Message =
	'Continuing with this action will save the current event details and yield distribution. You will need to create a new adjustment event for any further editions.'

const agCellWrapStyles = {
	alignItems: 'center',
	'white-space': 'nowrap',
	overflow: 'hidden',
	'text-overflow': 'ellipsis'
}

export {
	OVERLAY_MESSAGE,
	TABLEAU_DASH_CATEGORIES,
	NO_PUC,
	DEFAULT_PUC,
	PASSWORD_REGEX,
	PASSWORD_VALIDATION_MESSAGE,
	CONFIRM_PASSWORD_VALIDATION_MESSAGE,
	UserGroups,
	FIELDLENGTH_ERROR,
	REQUIRED,
	MIN_LATITUDE,
	MAX_LATITUDE,
	MIN_LONGITUDE,
	MAX_LONGITUDE,
	NUMBER,
	MAX_PHB_NUMBER,
	MODULES,
	PERMISSIONS,
	HECTARES_VAL_ERR,
	METRICS,
	Disposal_Val_Err,
	Block_Source,
	Date_Val_Err,
	Number_Val_Err,
	Crop_Census_Tranfers_Val_Err,
	Sentry_Custom_Err,
	Dirty_Form_Message,
	AgGrid_Header_Template,
	StartEndDates_Val_Err,
	Agronomy_AdjustmentEvent_Save_Message,
	agCellWrapStyles
}
